import React, { useEffect, useState, useCallback, useMemo } from "react";
import { HotTable } from "@handsontable/react";
import "handsontable/dist/handsontable.full.min.css";
import Handsontable from "handsontable";
import { registerAllModules } from "handsontable/registry";

registerAllModules();

class CalendarOnlyDateEditor extends Handsontable.editors.DateEditor {
  open() {
    super.open();
    if (this.TEXTAREA) {
      this.TEXTAREA.readOnly = true;
    }
  }
}
Handsontable.editors.registerEditor('calendarOnlyDate', CalendarOnlyDateEditor);

const AGREEMENT_Details_Table = ({ formState, setFormState, reviwerFlag }) => {
  const emptyAgreementRow = {
    agreementStartDate: "",
    agreementEndDate: "",
    tenure: 0,
    rentPerMonth: 0,
    totalPayment: 0,
    annuallyIncrease: 0,
    stampDuty: 0,
  };

  const [agreementTableData, setAgreementTableData] = useState(() => {
    if (formState?.Agreement_Details?.length > 0) {
      return formState.Agreement_Details;
    }
    return Array(3).fill(null).map(() => ({ ...emptyAgreementRow }));
  });
  const [showTenureLimitError, setShowTenureLimitError] = useState(false);

  // Memoize calculations to prevent unnecessary recalculations
  const { totalMonths, totalPayment, stampDutyTotal } = useMemo(() => {
    console.log(agreementTableData, "agreementTableData for calculations");
const months = agreementTableData.reduce(
  (sum, row) => sum + Number(row.tenure || 0),
  0
);

    const payment = agreementTableData.reduce((sum, row) => sum + (row.totalPayment || 0), 0);
    
    let stampDuty = 0;
    const province = formState?.provinceDuty?.[0]?.province || formState?.provinceDuty?.[0]?.Province;
    const stampDutyRate = formState?.provinceDuty?.[0]?.stampDutyRate || formState?.provinceDuty?.[0]?.StampDutyRate || 0;

    if (province === "Punjab" && months > 12) {
      const avgAnnual = (payment / months) * 12;
      stampDuty = parseFloat((avgAnnual * (stampDutyRate / 100)).toFixed(2));
    } else if (province === "Punjab" && months <= 12) {
      stampDuty = parseFloat((payment * (stampDutyRate / 100)).toFixed(2));
    }  else if (province === "Sindh") {
      stampDuty = parseFloat((payment * (stampDutyRate / 100)).toFixed(2));
    }
  //    const updatedRows = agreementTableData.map((row) => ({
  //   ...row,
  //   stampDuty: stampDuty,
  // }));

  // // avoid infinite loop by checking before update
  // if (JSON.stringify(updatedRows) !== JSON.stringify(agreementTableData)) {
  //   setAgreementTableData(updatedRows);
  // }

  setFormState((prev) => ({
    ...prev,
    stampDuty: stampDuty,
  }));

    return { totalMonths: months, totalPayment: payment, stampDutyTotal: stampDuty };
  }, [agreementTableData, formState?.provinceDuty]);

  // Calculate rent with increase for cascade updates
  const calculateRentWithIncrease = useCallback((baseRent, increasePercent) => {
    return parseFloat((baseRent * (1 + increasePercent / 100)).toFixed(2));
  }, []);

  // Calculate tenure between two dates
  // const calculateTenure = useCallback((startDate, endDate) => {
  //   const fromDate = new Date(startDate);
  //   const toDate = new Date(endDate);
  //   if (!isNaN(fromDate) && !isNaN(toDate)) {
  //     const diffInMs = toDate - fromDate;
  //     return parseFloat((diffInMs / (1000 * 60 * 60 * 24 * 30.44)).toFixed(2)); // More accurate month calculation
  //   }
  //   return 0;
  // }, []);


// const calculateTenure = useCallback((startDate, endDate) => {
//   if (!startDate || !endDate) return 0;

//   const start = new Date(startDate);
//   const end = new Date(endDate);

//   if (isNaN(start) || isNaN(end) || end < start) return 0;

//   // 1) month difference naive
//   const yearDiff = end.getFullYear() - start.getFullYear();
//   const monthDiff = end.getMonth() - start.getMonth();
//   let months = yearDiff * 12 + monthDiff;

//   // 2) Make a candidate date by adding `months` to start.
//   //    If that candidate is after `end`, reduce months by 1.
//   const candidate = new Date(start.getFullYear(), start.getMonth() + months, start.getDate());
//   if (candidate > end) {
//     months -= 1;
//   }

//   // Full months is now `months`
//   const fullMonths = months;

//   // 3) Start of partial period = start + fullMonths months
//   // Start partial (exclude start day)
// // const partialStart = (new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate() - start.getDate()) / new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
// const daysInStartMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
// const partialStart = (daysInStartMonth - start.getDate() + 1) / daysInStartMonth;

// // Full months in between (excluding start and end months)
// const middleFullMonths = Math.max(fullMonths , 0);
// // End partial (include end day)
// const endPartial = end.getDate() / new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate();

//   // If partialStart > end then partialDays = 0 (shouldn't usually happen after correction)
//   const msPerDay = 24 * 60 * 60 * 1000;
//   let partialFraction = 0;

//   if (partialStart <= end) {
//     // days between partialStart and end (inclusive)
//     const diffDaysInclusive = Math.floor((end - partialStart) / msPerDay) + 1;

//     // number of days in the end month
//     const daysInEndMonth = new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate();

//     partialFraction = diffDaysInclusive / daysInEndMonth;
//   }

//   // const tenure = parseFloat((fullMonths + partialFraction).toFixed(2));
//   const tenure = parseFloat((partialStart + middleFullMonths + endPartial).toFixed(2));
//   return tenure;
// }, []);


const calculateTenure = useCallback((startDate, endDate) => {
  if (!startDate || !endDate) return 0;

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (isNaN(start) || isNaN(end) || end < start) return 0;

  // Same-month range should be prorated within that month only.
  if (
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth()
  ) {
    const daysInMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
    const inclusiveDays = end.getDate() - start.getDate() + 1;
    return parseFloat((inclusiveDays / daysInMonth).toFixed(4));
  }

  // 1) Full months between start and end (excluding start & end months)
  let totalMonths = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) - 1;
  totalMonths = Math.max(totalMonths, 0);

  // 2) Partial start month
  const daysInStartMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
  const partialStart = (daysInStartMonth - start.getDate() + 1) / daysInStartMonth;

  // 3) Partial end month
  const daysInEndMonth = new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate();
  const partialEnd = end.getDate() / daysInEndMonth;

  const tenure = parseFloat((partialStart + totalMonths + partialEnd).toFixed(4));
  return tenure;
}, []);

  // Handle changes in the Handsontable
  const handleAfterChange = useCallback((changes, source) => {
    if (!changes || source === "loadData") return;

    let hasTenureLimitViolation = false;

    setAgreementTableData((prevData) => {
      const newData = [...prevData];
      let hasUpdate = false;

      changes.forEach(([rowIndex, prop, oldVal, newVal]) => {
        const row = newData[rowIndex];

        // Calculate tenure when dates change
        if (prop === "agreementStartDate" || prop === "agreementEndDate") {
          const tenure = calculateTenure(row.agreementStartDate, row.agreementEndDate);
          if (tenure > 12) {
            hasTenureLimitViolation = true;
            if (row.tenure !== 0 || row.totalPayment !== 0) {
              row.tenure = 0;
              row.totalPayment = 0;
              hasUpdate = true;
            }
          } else if (tenure !== row.tenure) {
            row.tenure = tenure;
            if (!isNaN(row.rentPerMonth) && row.rentPerMonth > 0) {
              row.totalPayment = Math.round(row.rentPerMonth * tenure);
            }
            hasUpdate = true;
          }
        }

        // Handle annually increase changes
        if (prop === "annuallyIncrease") {
          let prevRent = newData[rowIndex].rentPerMonth;

          for (let i = rowIndex + 1; i < newData.length; i++) {
            const increasePercent = parseFloat(newData[i - 1].annuallyIncrease) || 0;
            const increasedRent = calculateRentWithIncrease(prevRent, increasePercent);

            if (newData[i].rentPerMonth !== increasedRent) {
              newData[i].rentPerMonth = increasedRent;
              if (!isNaN(newData[i].tenure) && newData[i].tenure > 0) {
                newData[i].totalPayment = Math.round(increasedRent * newData[i].tenure);
              }
              prevRent = increasedRent;
              hasUpdate = true;
            }
          }
        }

        if (prop === "rentPerMonth") {
          const currentRent = parseFloat(newVal) || 0;
          if (row.rentPerMonth !== currentRent) {
            row.rentPerMonth = currentRent;
            hasUpdate = true;
          }

          if (!isNaN(row.tenure) && row.tenure > 0) {
            const newTotalPayment = Math.round(currentRent * row.tenure);
            if (row.totalPayment !== newTotalPayment) {
              row.totalPayment = newTotalPayment;
              hasUpdate = true;
            }
          }

          let prevRent = currentRent;
          for (let i = rowIndex + 1; i < newData.length; i++) {
            const increasePercent = parseFloat(newData[i - 1].annuallyIncrease) || 0;
            const increasedRent = calculateRentWithIncrease(prevRent, increasePercent);

            if (newData[i].rentPerMonth !== increasedRent) {
              newData[i].rentPerMonth = increasedRent;
              hasUpdate = true;
            }

            if (!isNaN(newData[i].tenure) && newData[i].tenure > 0) {
              const newTotalPayment = Math.round(increasedRent * newData[i].tenure);
              if (newData[i].totalPayment !== newTotalPayment) {
                newData[i].totalPayment = newTotalPayment;
                hasUpdate = true;
              }
            }

            prevRent = increasedRent;
          }
        }

        // Recalculate total payment when tenure changes
        if (prop === "tenure") {
          if (!isNaN(row.rentPerMonth) && !isNaN(row.tenure) && row.rentPerMonth > 0) {
            const newTotalPayment = Math.round(row.rentPerMonth * row.tenure);
            if (row.totalPayment !== newTotalPayment) {
              row.totalPayment = newTotalPayment;
              hasUpdate = true;
            }
          }
        }
      });

      return hasUpdate ? newData : prevData;
    });

    setShowTenureLimitError(hasTenureLimitViolation);
  }, [calculateTenure, calculateRentWithIncrease]);

  // Sync FCA rent to first row - ONLY when FCA_Details changes
  useEffect(() => {
    if (formState?.FCA_Details?.length > 0) {
      const fcaRent = parseFloat(formState.FCA_Details[0]?.newRent || 0);

      if (!isNaN(fcaRent) && fcaRent > 0) {
        setAgreementTableData((prevData) => {
          const updated = [...prevData];
          
          // Only update if different
          if (updated[0].rentPerMonth !== fcaRent) {
            updated[0].rentPerMonth = fcaRent;
            
            if (!isNaN(updated[0].tenure) && updated[0].tenure > 0) {
              updated[0].totalPayment = Math.round(fcaRent * updated[0].tenure);
            }

            // Cascade recalculation for subsequent rows
            for (let i = 1; i < updated.length; i++) {
              const baseRent = updated[i - 1].rentPerMonth;
              const increasePercent = parseFloat(updated[i - 1].annuallyIncrease) || 0;
              const increasedRent = calculateRentWithIncrease(baseRent, increasePercent);

              updated[i].rentPerMonth = increasedRent;
              if (!isNaN(updated[i].tenure) && updated[i].tenure > 0) {
                updated[i].totalPayment = Math.round(increasedRent * updated[i].tenure);
              }
            }

            return updated;
          }
          
          return prevData;
        });
      }
    }
  }, [formState?.FCA_Details, calculateRentWithIncrease]);

  // Sync local state to formState - with circular dependency protection
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setFormState((prev) => {
        if (agreementTableData.some((row) => Number(row.tenure || 0) > 12)) {
          return prev;
        }

        // Only update if different and not coming from formState update
        const currentFormStateString = JSON.stringify(prev.Agreement_Details);
        const localStateString = JSON.stringify(agreementTableData);
        
        if (currentFormStateString !== localStateString) {
          return {
            ...prev,
            Agreement_Details: [...agreementTableData],
          };
        }
        return prev;
      });
    }, 100); // Small debounce

    return () => clearTimeout(timeoutId);
  }, [agreementTableData, setFormState]);

  // Initialize from formState.Agreement_Details when it changes
  useEffect(() => {
    if (Array.isArray(formState?.Agreement_Details) && formState.Agreement_Details.length > 0) {
      const mapped = formState.Agreement_Details.map(item => ({
        agreementStartDate: (item?.AgreementStartDate || item?.agreementStartDate) || "",
        agreementEndDate: (item?.AgreementEndDate || item?.agreementEndDate) || "",
        annuallyIncrease: item?.annuallyIncrease || item?.AnnuallyIncrease || 0,
        tenure: item.Tenure || item.tenure || 0,
        rentPerMonth: Number(item?.RentPerMonth || item?.rentPerMonth) || 0,
        totalPayment: item.TotalPayment || item.totalPayment || 0,
        stampDuty: Number(item.stampDuty || item.StampDuty) || 0,
      }));

      // Only update if different to prevent infinite loops
      const currentDataString = JSON.stringify(agreementTableData);
      const mappedDataString = JSON.stringify(mapped);
      
      if (currentDataString !== mappedDataString) {
        setAgreementTableData(mapped);
      }
    }
  }, [formState?.Agreement_Details]); // Watch for changes in Agreement_Details

  const agreementTableHeaders = [
    "Agreement Start Date",
    "Agreement End Date",
    "Tenure (Months)",
    "Rent Per Month (From FCA)",
    "Amount",
    "Annual Increase %",
  ];

  const agreementTableColumns = [
    { data: "agreementStartDate", type: "date", dateFormat: "DD-MMM-YYYY",editor: "calendarOnlyDate" },
    { data: "agreementEndDate", type: "date", dateFormat: "DD-MMM-YYYY",editor: "calendarOnlyDate"},
    { data: "tenure", type: "numeric", readOnly: true },
    { data: "rentPerMonth", type: "numeric", readOnly: true , numericFormat: {
    pattern: "0,0",  // ✅ Adds comma separators
    culture: "en-GB" // ✅ Apply locale
  }, },
    { data: "totalPayment", type: "numeric", readOnly: true , numericFormat: {
      pattern: "0,0", // ✅ Adds comma separators
    }, },
    { data: "annuallyIncrease", type: "numeric" , numericFormat: {
      pattern: "0,0", // ✅ Adds comma separators  
    },
    hidden: true
  },
  ];

  const hasTenureMoreThanTwelve = useMemo(() => {
    return agreementTableData.some((row) => Number(row.tenure || 0) > 12);
  }, [agreementTableData]);

  const tenureValidationMessage = useMemo(() => {
    return hasTenureMoreThanTwelve || showTenureLimitError
      ? "Tenure can be of 12 months , Add new row to add more"
      : "";
  }, [hasTenureMoreThanTwelve, showTenureLimitError]);

  return (
    <div>
      <div style={{ position: 'relative' }}>
        <HotTable
          data={agreementTableData}
          colHeaders={agreementTableHeaders}
          columns={agreementTableColumns}
          rowHeaders={true}
          licenseKey="non-commercial-and-evaluation"
          afterChange={handleAfterChange}  
          readOnly={reviwerFlag}
          stretchH="all"
          width="100%"
          height="auto"
     cells={(row, col) => {
  const cellProperties = {};
  const annualIncreaseColIndex = 5;
  const rentPerMonthColIndex = 3;
const lastRowIndex = agreementTableData.length - 1;

  if (col === rentPerMonthColIndex && row === 0) {
    cellProperties.readOnly = false;
    return cellProperties;
  }

if (col === annualIncreaseColIndex && row === lastRowIndex) {
    cellProperties.renderer = (instance, td) => {
      td.innerHTML = "";
      td.style.display = "none";
    };
    return cellProperties; // stop here ONLY for this cell
  }
  if (agreementTableColumns[col]?.readOnly) {
    const column = agreementTableColumns[col];
    
    if (column.type === "numeric") {
      // Use numeric renderer with formatting
      cellProperties.renderer = (instance, td, row, col, prop, value, cellProperties) => {
        // Apply numeric rendering first
        Handsontable.renderers.NumericRenderer.call(
          this,
          instance,
          td,
          row,
          col,
          prop,
          value,
          cellProperties
        );
        // Then apply grey background
        td.style.background = "#f0f0f0";
        td.style.color = "#000";
      };
    } else {
      cellProperties.renderer = (instance, td, row, col, prop, value, cellProperties) => {
        Handsontable.renderers.TextRenderer.call(
          this,
          instance,
          td,
          row,
          col,
          prop,
          value,
          cellProperties
        );
        td.style.background = "#f0f0f0";
        td.style.color = "#000";
      };
    }
  }
  return cellProperties;
}}
        />

        {/* Summary row */}
        <div style={{ 
          display: 'flex', 
          marginTop: '8px', 
          fontWeight: 'bold',
          position: 'relative',
          paddingLeft: '50px'
        }}>
          <div style={{ flex: '1' }}></div>
          <div style={{ flex: '1' }}></div>
          
          <div style={{ 
            flex: '1', 
            textAlign: 'center',
            padding: '4px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #ddd',
            fontSize: '12px',
            marginRight: '2px'
          }}>
         Total Months: {Number(totalMonths.toFixed(2)).toLocaleString("en-US")}

          </div>
          
          <div style={{ flex: '1' }}></div>
          
          <div style={{ 
            flex: '1', 
            textAlign: 'center',
            padding: '4px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #ddd',
            fontSize: '12px'
          }}>
             Total Agreement Amount: {totalPayment?.toLocaleString("en-US")}
          </div>
          
          <div style={{ 
            flex: '1', 
            textAlign: 'center',
            padding: '4px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #ddd',
            fontSize: '12px',
            marginLeft: '2px'
          }}>
            Stamp Duty: {Math.round(stampDutyTotal)?.toLocaleString("en-US")}
          </div>
        </div>

        {tenureValidationMessage && (
          <div style={{
            marginTop: "8px",
            color: "#d93025",
            fontSize: "16px",
            fontWeight: 700,
          }}>
            {tenureValidationMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default AGREEMENT_Details_Table;